module.exports = __webpack_public_path__ + "media/promotions/deals-and-promos_300x150-abb3e2e6.png";